module.exports = __webpack_public_path__ + "static/img/get-to-the-management-team_4.4aa4085.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/get-to-the-management-team_4.png
// module id = gMTK
// module chunks = 0